import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "src/redux/action/api";

const ReportingAppSlice = createSlice({
  name: "reportingApp",
  initialState: {
    selectedEntity: null,
    deviceReportingTokens: {},
    publicReportingTokens: {},
    publicMissionsList: null,
    publicReportingApiKeyResult: null
  },
  reducers: {
    setDeviceReportingToken(state, action) {
      const { meta, data } = action.payload;

      return { 
        ...state, 
        deviceReportingTokens: { 
          ...state.deviceReportingTokens, 
          [meta?.deviceId]: {
            url: data?.url,
            timestamp: new Date().getTime(),
            ...meta,
          },
        } 
      };
    },
    setPublicReportingTokens(state, action) {
      const { meta, data } = action.payload;

      return { 
        ...state, 
        publicReportingTokens: { 
          ...state.publicReportingTokens, 
          [meta?.deviceId]: {
            url: data?.url,
            timestamp: new Date().getTime(),
            ...meta,
          },
        } 
      };
    },
    setPublicMissionsList(state, action) {
      const { meta, data } = action.payload;

      return { 
        ...state, 
        publicMissionsList: {
          missions: data?.missions,
          timestamp: new Date().getTime(),
        }
      };
    },
    setPublicReportingApiKey(state, action) {
      const { data } = action.payload;

      return { 
        ...state, 
        publicReportingApiKeyResult: data
      };
    },
  },
});

export const {
  setDeviceReportingToken,
  setPublicReportingTokens,
  setPublicMissionsList,
  setPublicReportingApiKey,
} = ReportingAppSlice.actions;
export default ReportingAppSlice.reducer;

export const getDeviceReportingToken = (data) => {
  return apiCallBegan({
    url: `/devices/app/reporting/token`,
    method: "Post",
    data,
    onSuccess: setDeviceReportingToken.type,
    onError: setDeviceReportingToken.type,
    meta: data,
  })};

  export const getPublicReportingToken = (data) => {
    return apiCallBegan({
      url: `~/public/api/v1.0/reporting/${data?.deviceId}/token`,
      method: "Get",
      onSuccess: setPublicReportingTokens.type,
      onError: setPublicReportingTokens.type,
      headers: {
        "x-api-key": data?.apiKey,
      },
      meta: data,
    })};

  export const getPublicMissions = (data) => {
    return apiCallBegan({
      url: `~/public/api/v1.0/missions?offset=0&limit=100`,
      method: "Get",
      onSuccess: setPublicMissionsList.type,
      onError: setPublicMissionsList.type,
      headers: {
        "x-api-key": data?.apiKey,
      },
    })};

    export const getAccountPublicReportingApiKey = (data) => {
      return apiCallBegan({
        url: `/devices/app/reporting/public-dashboard`,
        method: "Post",
        data,
        onSuccess: setPublicReportingApiKey.type,
        onError: setPublicReportingApiKey.type,
      })};